import { Component, OnInit } from '@angular/core';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { Subscription } from 'rxjs';
import { FacilityService } from '../../../../core/services/facility.service';
import { environment } from '../../../../../environments/environment';
import { AddBodyserialService } from '../../../services/add-bodyserial.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EquipmentService } from '../../../services/equipment.service';
import { equipmentObject, onboardingEquipmentObject } from '../../../services/equipment.model';
import { HaloLoaderService } from '../../../../core/halo-loader/halo-loader.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';


@Component({
  selector: 'app-add-equipment',
  templateUrl: './add-equipment.component.html',
  styleUrls: ['./add-equipment.component.scss']
})
export class AddEquipmentComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  private _facilityOnChange: Subscription;
  private _onBoardingAuthOnChange: Subscription;

  newEquipmentList: onboardingEquipmentObject[];
  newEquipmentExists: boolean = false;
  newEquipmentRegistered: boolean = false;
  newAvailEquipmentList: onboardingEquipmentObject[];
  newRegisteredEquipmentList: onboardingEquipmentObject[];
  showAddOldEquipment: boolean = false;
  showAddNewEquipment: boolean = false;


  constructor(private _rootScopeService: RootScopeService, private _facilityService: FacilityService,
    private _addbodyserial: AddBodyserialService, private router: Router,
    private _route: ActivatedRoute,
    private _ampAnalytics: AmplitudeAnalyticsService,
    private _equipmentService: EquipmentService,
    private _loader: HaloLoaderService
  ) { }

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'Facility - Equipment';
  }

  ngOnInit(): void {
    this.getRootScopeData();
    this.setPageName();
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
    });

    
    this. _onBoardingAuthOnChange = this._equipmentService.getOnboardingAuth().subscribe(
      (data: { 'authToken': string }) => {
        localStorage.setItem('gaeapptoken', data.authToken);
      },
      (error) => {
        console.error('API failed.');
      }
    );

    if(history.state['action']){
      if(history.state.action === '1'){
        this.showAddOldEquipment = true;
        this.showAddNewEquipment = false;
      }
      else{
        this.fetchNewEquipmentList();
      }
    } else{
      this.fetchNewEquipmentList();
    }

  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
    if(this._onBoardingAuthOnChange){
      this._onBoardingAuthOnChange.unsubscribe();
    }
  }

  fetchNewEquipmentList(): void {
    this.newEquipmentExists = false;
    this.newEquipmentRegistered = false;
    this.newEquipmentList = [];
    this.newAvailEquipmentList = [];
    this.newRegisteredEquipmentList = [];
    this._loader.startProcess();
    this._equipmentService.getOnboardingEquipmentData().subscribe(
      (data: onboardingEquipmentObject[]) => {
        this.newEquipmentList = data;
        // this.newEquipmentList = [

        //   {

        //     "equipmentUUID": "dfabd1e1-770a-4a51-b599-53f928618099",

        //     "bodySerial": "FBN100072",

        //     "consoleSerial": "FSN100072",

        //     "facilityId": 13149,

        //     "equipmentStatus": "REGISTERED",

        //     "csafemodelId": 21

        //   },

        //   {

        //     "equipmentUUID": "fd87a1fb-4ae3-429f-b682-114fb8047ad4",

        //     "bodySerial": "FBS100092",

        //     "consoleSerial": "FCS100092",

        //     "facilityId": 13150,

        //     "equipmentStatus": "ACTIVATED",

        //     "csafemodelId": 94

        //   }

        // ];
        if (this.newEquipmentList.length > 0) {
          this.newEquipmentExists = true;
          for (let index in this.newEquipmentList) {
            if (this.newEquipmentList[index].facilityId.toString() === this.currentFacility.facilityId) {
              this.newEquipmentRegistered = true;
              this.newRegisteredEquipmentList.push(this.newEquipmentList[index]);
            }
            if (this.newEquipmentList[index].equipmentStatus === 'ACTIVATED' && this.newEquipmentList[index].facilityId.toString() !== this.currentFacility.facilityId) {
              this.newAvailEquipmentList.push(this.newEquipmentList[index]);
            }

          }

          this.showAddOldEquipment = false;
          this.showAddNewEquipment = true;

        }else{
          this.showAddOldEquipment = true;
          this.showAddNewEquipment = false;
        }
        this._loader.endProcess();
      },
      (error) => {
        this.newEquipmentList = [];
        this.showAddOldEquipment = true;
        this.showAddNewEquipment = false;
        console.error('API failed.');
        this._loader.endProcess();
      }
      //TODO: Need to check on the below line of code (completion () of subscribe) and remove endProcess from success and error function
      // , () => {
      //   this._loader.endProcess();
      // }
    );
  }

  showOldAddEquipmentScreen(): void{
    this.showAddOldEquipment = true;
    this.showAddNewEquipment = false;
  }

}
